// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Side_bar_sidebar_navbar__5mywY {
  width: 100%;
}

.Side_bar_side_bar__00HY- {
  --icon-bg: rgba(255, 255, 255, 0.14);
  --icon-color: #ffffff;
  --active-bg: rgba(255, 255, 255, 0.16);
  --active-text: #ffffff;
  --active-icon-bg: linear-gradient(135deg, #ffffff 0%, #F1EBFF 100%);
  --active-icon-color: #4c2fb3;
  --text: rgba(255, 255, 255, 0.88);
  --muted: rgba(255, 255, 255, 0.5);
  --chev: rgba(255, 255, 255, 0.45);
  --dot: rgba(255, 255, 255, 0.35);
  --accent: #FFD166;

  width: 264px;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
  background: linear-gradient(165deg, #24123f 0%, #4c2fb3 55%, #7c5cfc 100%);
  box-shadow: 6px 0 28px rgba(20, 10, 46, 0.22);
  padding: 14px 12px 32px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  list-style: none;
  margin: 0;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;
  z-index: 1050;
}

.Side_bar_closeButton__U1-H9 {
  display: none;
}

@media screen and (max-width: 768px) {
  .Side_bar_side_bar__00HY- {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    width: min(82vw, 310px);
    height: 100dvh;
    padding-top: 18px;
    animation: Side_bar_drawerIn__zG1mf 0.2s ease-out;
  }

  .Side_bar_closeButton__U1-H9 {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 1;
    width: 32px;
    height: 32px;
    border: 1px solid rgba(255, 255, 255, 0.22);
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.12);
    color: #ffffff;
    font-size: 24px;
    line-height: 1;
    cursor: pointer;
  }

  .Side_bar_closeButton__U1-H9:hover {
    background: rgba(255, 255, 255, 0.22);
  }
}

@keyframes Side_bar_drawerIn__zG1mf {
  from { transform: translateX(-100%); }
  to { transform: translateX(0); }
}

.Side_bar_side_bar__00HY-::-webkit-scrollbar {
  width: 5px;
}
.Side_bar_side_bar__00HY-::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.22);
  border-radius: 10px;
}
.Side_bar_side_bar__00HY-::-webkit-scrollbar-track {
  background: transparent;
}

.Side_bar_brandLink__DnYbU {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px 8px 18px;
  margin-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.14);
  text-decoration: none;
}

.Side_bar_sideBarLogo__5gbvu {
  width: 42px;
  height: 42px;
  object-fit: contain;
  padding: 7px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(20, 10, 46, 0.35);
  flex-shrink: 0;
}

.Side_bar_brandName__FYvEo {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 16.5px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.01em;
  line-height: 1.15;
}

.Side_bar_brandTagline__Fnt6Q {
  display: block;
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.55);
  margin-top: 2px;
}

.Side_bar_sectionLabel__bxMN7 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: var(--muted);
  text-transform: uppercase;
  margin: 22px 10px 10px;
}

.Side_bar_sectionLabel__bxMN7::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: rgba(255, 255, 255, 0.12);
}

.Side_bar_navItem__rsHYx {
  list-style: none;
  margin-bottom: 2px;
}

.Side_bar_navLink__3DVea {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-radius: 12px;
  cursor: pointer;
  color: var(--text) !important;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
  text-decoration: none !important;
  transition: background-color 0.18s ease, color 0.18s ease, transform 0.12s ease;
}

.Side_bar_navLink__3DVea:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateX(2px);
}

.Side_bar_navLink__3DVea.Side_bar_active__eZunT,
.Side_bar_navLink__3DVea[aria-expanded="true"].Side_bar_active__eZunT {
  background: var(--active-bg);
  color: var(--active-text) !important;
  font-weight: 600;
}

.Side_bar_navLink__3DVea.Side_bar_active__eZunT::before {
  content: "";
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 3px;
  background: var(--accent);
}

.Side_bar_active__eZunT {
  background: var(--active-bg);
  color: var(--active-text) !important;
  font-weight: 600;
}

.Side_bar_listItems__Ohpc8 {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.Side_bar_listItems__Ohpc8 span:last-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Side_bar_navIconWrap__FZKRd {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--icon-bg);
  color: var(--icon-color);
  flex-shrink: 0;
  transition: background 0.18s ease, color 0.18s ease;
}

.Side_bar_navLink__3DVea.Side_bar_active__eZunT .Side_bar_navIconWrap__FZKRd {
  background: var(--active-icon-bg);
  color: var(--active-icon-color);
  box-shadow: 0 4px 10px rgba(20, 10, 46, 0.3);
}

.Side_bar_navIconWrap__FZKRd svg {
  font-size: 17px !important;
}

.Side_bar_chev__wQj17 {
  width: 15px;
  height: 15px;
  color: var(--chev);
  flex-shrink: 0;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.Side_bar_submenu__Jboio {
  display: flex;
  flex-direction: column;
  margin: 4px 0 8px 26px;
  padding-left: 18px;
  border-left: 1px solid rgba(255, 255, 255, 0.16);
}

.Side_bar_subItem__XOzPw {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 9px;
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.01em;
  color: rgba(255, 255, 255, 0.68) !important;
  cursor: pointer;
  text-decoration: none !important;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.Side_bar_subItem__XOzPw:hover {
  background: rgba(255, 255, 255, 0.09);
  color: #ffffff !important;
}

.Side_bar_subItem__XOzPw.Side_bar_active__eZunT {
  background: var(--active-bg);
  color: var(--active-text) !important;
  font-weight: 600;
}

.Side_bar_subDot__uLlGN {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--dot);
  display: inline-block;
  flex-shrink: 0;
}

.Side_bar_subItem__XOzPw.Side_bar_active__eZunT .Side_bar_subDot__uLlGN {
  background: var(--accent);
}

.Side_bar_tabsInnerDiv__y2v-Y {
  /* kept for backward compatibility with any leftover references */
  background: transparent;
}

.Side_bar_collapseitemText__DlUmx {
  color: rgba(255, 255, 255, 0.72);
}

.Side_bar_icon_color__\\+-2x2 {
  color: var(--icon-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/thememaker/sidebar/Side_bar.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,sCAAsC;EACtC,sBAAsB;EACtB,mEAAmE;EACnE,4BAA4B;EAC5B,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,gCAAgC;EAChC,iBAAiB;;EAEjB,YAAY;EACZ,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,gBAAgB;EAChB,0EAA0E;EAC1E,6CAA6C;EAC7C,uBAAuB;EACvB,uFAAuF;EACvF,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,sDAAsD;EACtD,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;IACf,OAAO;IACP,MAAM;IACN,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,iDAAiC;EACnC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,kBAAkB;IAClB,qCAAqC;IACrC,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,wBAAwB,EAAE;AACjC;;AAEA;EACE,UAAU;AACZ;AACA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,kDAAkD;EAClD,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,+EAA+E;AACjF;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;;EAEE,4BAA4B;EAC5B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C;EAC3C,eAAe;EACf,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iEAAiE;EACjE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".sidebar_navbar {\n  width: 100%;\n}\n\n.side_bar {\n  --icon-bg: rgba(255, 255, 255, 0.14);\n  --icon-color: #ffffff;\n  --active-bg: rgba(255, 255, 255, 0.16);\n  --active-text: #ffffff;\n  --active-icon-bg: linear-gradient(135deg, #ffffff 0%, #F1EBFF 100%);\n  --active-icon-color: #4c2fb3;\n  --text: rgba(255, 255, 255, 0.88);\n  --muted: rgba(255, 255, 255, 0.5);\n  --chev: rgba(255, 255, 255, 0.45);\n  --dot: rgba(255, 255, 255, 0.35);\n  --accent: #FFD166;\n\n  width: 264px;\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  overflow-y: auto;\n  background: linear-gradient(165deg, #24123f 0%, #4c2fb3 55%, #7c5cfc 100%);\n  box-shadow: 6px 0 28px rgba(20, 10, 46, 0.22);\n  padding: 14px 12px 32px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  list-style: none;\n  margin: 0;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;\n  z-index: 1050;\n}\n\n.closeButton {\n  display: none;\n}\n\n@media screen and (max-width: 768px) {\n  .side_bar {\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: min(82vw, 310px);\n    height: 100dvh;\n    padding-top: 18px;\n    animation: drawerIn 0.2s ease-out;\n  }\n\n  .closeButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    z-index: 1;\n    width: 32px;\n    height: 32px;\n    border: 1px solid rgba(255, 255, 255, 0.22);\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.12);\n    color: #ffffff;\n    font-size: 24px;\n    line-height: 1;\n    cursor: pointer;\n  }\n\n  .closeButton:hover {\n    background: rgba(255, 255, 255, 0.22);\n  }\n}\n\n@keyframes drawerIn {\n  from { transform: translateX(-100%); }\n  to { transform: translateX(0); }\n}\n\n.side_bar::-webkit-scrollbar {\n  width: 5px;\n}\n.side_bar::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.22);\n  border-radius: 10px;\n}\n.side_bar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.brandLink {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 10px 8px 18px;\n  margin-bottom: 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.14);\n  text-decoration: none;\n}\n\n.sideBarLogo {\n  width: 42px;\n  height: 42px;\n  object-fit: contain;\n  padding: 7px;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 12px;\n  box-shadow: 0 6px 16px rgba(20, 10, 46, 0.35);\n  flex-shrink: 0;\n}\n\n.brandName {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 16.5px;\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: 0.01em;\n  line-height: 1.15;\n}\n\n.brandTagline {\n  display: block;\n  font-family: 'Inter', sans-serif;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.55);\n  margin-top: 2px;\n}\n\n.sectionLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  color: var(--muted);\n  text-transform: uppercase;\n  margin: 22px 10px 10px;\n}\n\n.sectionLabel::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.navItem {\n  list-style: none;\n  margin-bottom: 2px;\n}\n\n.navLink {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border-radius: 12px;\n  cursor: pointer;\n  color: var(--text) !important;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  text-decoration: none !important;\n  transition: background-color 0.18s ease, color 0.18s ease, transform 0.12s ease;\n}\n\n.navLink:hover {\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateX(2px);\n}\n\n.navLink.active,\n.navLink[aria-expanded=\"true\"].active {\n  background: var(--active-bg);\n  color: var(--active-text) !important;\n  font-weight: 600;\n}\n\n.navLink.active::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 8px;\n  bottom: 8px;\n  width: 3px;\n  background: var(--accent);\n}\n\n.active {\n  background: var(--active-bg);\n  color: var(--active-text) !important;\n  font-weight: 600;\n}\n\n.listItems {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.listItems span:last-child {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.navIconWrap {\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--icon-bg);\n  color: var(--icon-color);\n  flex-shrink: 0;\n  transition: background 0.18s ease, color 0.18s ease;\n}\n\n.navLink.active .navIconWrap {\n  background: var(--active-icon-bg);\n  color: var(--active-icon-color);\n  box-shadow: 0 4px 10px rgba(20, 10, 46, 0.3);\n}\n\n.navIconWrap svg {\n  font-size: 17px !important;\n}\n\n.chev {\n  width: 15px;\n  height: 15px;\n  color: var(--chev);\n  flex-shrink: 0;\n  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.submenu {\n  display: flex;\n  flex-direction: column;\n  margin: 4px 0 8px 26px;\n  padding-left: 18px;\n  border-left: 1px solid rgba(255, 255, 255, 0.16);\n}\n\n.subItem {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 9px;\n  font-family: 'Inter', sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  color: rgba(255, 255, 255, 0.68) !important;\n  cursor: pointer;\n  text-decoration: none !important;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.subItem:hover {\n  background: rgba(255, 255, 255, 0.09);\n  color: #ffffff !important;\n}\n\n.subItem.active {\n  background: var(--active-bg);\n  color: var(--active-text) !important;\n  font-weight: 600;\n}\n\n.subDot {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: var(--dot);\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n.subItem.active .subDot {\n  background: var(--accent);\n}\n\n.tabsInnerDiv {\n  /* kept for backward compatibility with any leftover references */\n  background: transparent;\n}\n\n.collapseitemText {\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.icon_color {\n  color: var(--icon-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar_navbar": `Side_bar_sidebar_navbar__5mywY`,
	"side_bar": `Side_bar_side_bar__00HY-`,
	"closeButton": `Side_bar_closeButton__U1-H9`,
	"drawerIn": `Side_bar_drawerIn__zG1mf`,
	"brandLink": `Side_bar_brandLink__DnYbU`,
	"sideBarLogo": `Side_bar_sideBarLogo__5gbvu`,
	"brandName": `Side_bar_brandName__FYvEo`,
	"brandTagline": `Side_bar_brandTagline__Fnt6Q`,
	"sectionLabel": `Side_bar_sectionLabel__bxMN7`,
	"navItem": `Side_bar_navItem__rsHYx`,
	"navLink": `Side_bar_navLink__3DVea`,
	"active": `Side_bar_active__eZunT`,
	"listItems": `Side_bar_listItems__Ohpc8`,
	"navIconWrap": `Side_bar_navIconWrap__FZKRd`,
	"chev": `Side_bar_chev__wQj17`,
	"submenu": `Side_bar_submenu__Jboio`,
	"subItem": `Side_bar_subItem__XOzPw`,
	"subDot": `Side_bar_subDot__uLlGN`,
	"tabsInnerDiv": `Side_bar_tabsInnerDiv__y2v-Y`,
	"collapseitemText": `Side_bar_collapseitemText__DlUmx`,
	"icon_color": `Side_bar_icon_color__+-2x2`
};
export default ___CSS_LOADER_EXPORT___;
